export const validateToken = (response:any) => {
    if(response?.status === 403 && response?.data?.message === "El token no es válido"){
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = window.location.origin;
        return false;
    } 
    return true;
}